import { Controller } from '@hotwired/stimulus';
import { debounce } from '../../utilities/debounce';

type Element = HTMLInputElement | HTMLSelectElement | HTMLButtonElement;

export default class extends Controller {
  private readonly SUBMIT_DEBOUNCE_TIME = 300;

  private readonly elementsToDisable = [
    'input',
    'button',
    'textarea',
    'select',
  ];

  initialize() {
    document.body.style.cursor = 'auto';
    super.initialize();

    this.element.addEventListener(
      'change',
      debounce(this.submit.bind(this), this.SUBMIT_DEBOUNCE_TIME),
    );
  }

  disconnect() {
    this.element.removeEventListener(
      'change',
      debounce(this.submit.bind(this), this.SUBMIT_DEBOUNCE_TIME),
    );
  }

  submit() {
    document.body.style.cursor = 'progress';
    (this.element as HTMLFormElement).requestSubmit();
    this.disableElements();
  }

  private disableElements() {
    const formElementTargets = this.element.querySelectorAll(
      this.elementsToDisable.join(', '),
    );
    for (const formElement of formElementTargets) {
      (formElement as Element).disabled = true;
    }
  }
}
